import { type ReactNode } from 'react';
import { useMedia } from 'react-use';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import styles from './OneColTwoCol.module.css';

interface Props {
  leftCol: ReactNode;
  rightCol: ReactNode;
}

export function OneColTwoCol(props: Props) {
  const { leftCol, rightCol } = props;
  const isDesktop = useMedia(BreakpointQueryLarge);
  return (
    <div className={styles.container}>
      <div className={styles.col}>{leftCol}</div>
      {isDesktop === true && <div className={styles.right}>{rightCol}</div>}
    </div>
  );
}
